import { type QueryClient } from "@tanstack/react-query";

/** Matches HyperTable `tableId` / `uniqueQueryId` on OpportunitiesTable */
export const OPPORTUNITIES_TABLE_QUERY_KEY = "opportunities-table";

export const EVENT_PARTICIPANT_TAB_COUNTS_QUERY_KEY =
  "event-participant-tab-counts";

export function invalidateOpportunitiesTableQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    queryKey: [OPPORTUNITIES_TABLE_QUERY_KEY],
    exact: false,
  });
}

/** After add/approve/remove participants - refresh event card + participant tables. */
export function invalidateEventParticipantQueries(
  queryClient: QueryClient,
  opportunityId?: string,
) {
  const prefixes = [
    "opportunity-interested-table",
    "optional-volunteer-groups-table",
    EVENT_PARTICIPANT_TAB_COUNTS_QUERY_KEY,
    ...(opportunityId
      ? [
          ["event-card", opportunityId],
          ["event-participant-tab-counts", opportunityId],
          `optional-volunteer-groups-add-${opportunityId}`,
          `participants-groups-${opportunityId}`,
          `participants-individuals-${opportunityId}`,
          `participants-approved-${opportunityId}`,
          `participants-table-${opportunityId}`,
        ]
      : []),
  ];

  return Promise.all([
    invalidateOpportunitiesTableQueries(queryClient),
    ...prefixes.map((queryKey) =>
      queryClient.invalidateQueries({
        queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
        exact: false,
      }),
    ),
  ]);
}
